import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function PenaltyContent({
  handleAddModal,
  handleEdit,
  // handleRemove,
  // penaltyId,
  getSinglePenalty,
  penaltyInfo,
  // removePenalty,
  // history,
  // getPenaltyList,
  // UpdateData,
  // penaltyList,
  match,
  clearTransaction,
}) {
  const selectedTransaction = match.params.penaltyId;

  // const handleRemove = (data) => (e) => {
  //   e.preventDefault();
  //   ConfirmAlert(
  //     'Are you sure, you want to remove this Penalty?',
  //     () => {
  //       removePenalty(data.id);
  //       UpdateData();
  //       history.push(`/rpt/settings/penalties`);
  //       getPenaltyList();
  //       getSinglePenalty(selectedTransaction);
  //     },
  //     () => { },
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     }
  //   );
  // };

  const updateData = () => {
    getSinglePenalty(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  return (
    <div className="container-fluid card-section-content">
      <div className="row bg-white pr-2 py-2 mb-2">
        {_.isEmpty(penaltyInfo) ? (
          <div className="col-12 d-flex ">
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
            >
              Add&nbsp;
              <i className="fas fa-plus" />
            </button>
          </div>
        ) : (
          <div />
        )}
      </div>
      {!_.isEmpty(penaltyInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="row d-flex justify-content-between align-items-center">
                <div className="col-10">
                  <h3 className="">Information</h3>
                </div>
                <div className="col-2 d-flex">
                  <div className="ml-auto">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(penaltyInfo)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    {/* <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemove(penaltyInfo)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button> */}
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col-12">
                    <div className="form-wrapper mb-3">
                      <div className="full-group border-bottom">
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">Name:</label>
                            <span className="full-input">
                              {_.get(penaltyInfo, 'attributes.name') || '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">Code:</label>
                            <span className="full-input">
                              {_.get(penaltyInfo, 'attributes.description') ||
                                '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">
                              Monthly Penalty Percentage:
                            </label>
                            <span className="full-input">
                              {_.get(penaltyInfo, 'attributes.surcharge') ||
                                '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">
                              Maximum Penalty Percentage:
                            </label>
                            <span className="full-input">
                              {_.get(penaltyInfo, 'attributes.max_surcharge') ||
                                '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">
                              Ordinance Revision:
                            </label>
                            <span className="full-input">
                              {_.get(
                                penaltyInfo,
                                'attributes.ordinance_revision_name'
                              ) || '--'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justify-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

PenaltyContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  // UpdateData: PropTypes.instanceOf(Function).isRequired,
  // getPenaltyList: PropTypes.instanceOf(Function).isRequired,
  // removePenalty: PropTypes.instanceOf(Function).isRequired,
  getSinglePenalty: PropTypes.instanceOf(Function).isRequired,
  penaltyInfo: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  // history: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  penaltyInfo: _.get(api, `${c.GET_SINGLE_PENALTY}.item`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PenaltyContent);
